import { Navigate, Route, Routes } from 'react-router-dom'
import NewCoupon from '../pages/Coupons/NewCoupon'
import NewTemplate from '../pages/NewTemplate/NewTemplate'
import TemplateDashboard from '../pages/TemplateDashboard/TemplateDashboard'
import TemplateDetail from '../pages/TemplateDetail/TemplateDetail'
import TemplateEditForm from '../pages/TemplateEditForm/TemplateEditForm'

const PrivateRouter = () => {
  return (
    <Routes>
      <Route path="/template" element={<TemplateDashboard />} />
      <Route path="/template/:id" element={<TemplateDetail />} />
      <Route path="/template/update/:id" element={<TemplateEditForm />} />
      <Route path="/template/create" element={<NewTemplate />} />
      <Route path="/coupon/create" element={<NewCoupon />} />
      <Route path="/" element={<Navigate to="/template" />} />
      <Route path="/*" element={<TemplateDashboard />} />
    </Routes>
  )
}

export default PrivateRouter
